import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingStaff } from "app/services/StaffService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class PermissionStaffStore {
  pagePermissionStaff = new PageResponse();
  searchPermissionStaff = {
    ...new SearchObject(),
    pageSize: 10,
    staffIds: [],
  };
  constructor() {
    makeAutoObservable(this);
  }

  pagingPermissionStaff = async () => {
    const searchObj = this.normalizeSearch(this.searchPermissionStaff);
    return await pagingStaff({ ...searchObj, getPermission: true })
      .then(({ data }) => {
        this.pagePermissionStaff = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu phân quyền nhân viên có lỗi");
      });
  };

  handleChangeFormSearch = (values) => {
    this.searchPermissionStaff = {
      ...this.searchPermissionStaff,
      ...values,
    };

    this.pagingPermissionStaff();
  };

  normalizeSearch = (rawSearch = {}) => {
    const {
      departmentId,
      deptIdOfStaffInRoom,
      roomId,
      position,
      roleIds,
      staffIds,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      departmentId: departmentId?.id,
      roomId: roomId?.id,
      positionCode: position?.code,
      deptIdOfStaffInRoom: deptIdOfStaffInRoom?.id,
      roleIds: roleIds?.map((el) => el?.id) || [],
      staffIds: staffIds?.map((el) => el?.id) || [],
    };
  };
}
